import { render, staticRenderFns } from "./MortgageSelection.vue?vue&type=template&id=1c32d7db"
import script from "./MortgageSelection.vue?vue&type=script&lang=js"
export * from "./MortgageSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports